<template>
  <v-dialog v-model="internalVisible" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline" style="color: whitesmoke">
        <v-icon color="white" class="mr-2">mdi-timeline-clock</v-icon>
        Historial del caso
      </v-card-title>
      <v-card-text>
        <v-timeline dense>
          <v-timeline-item
            v-for="h in historialFiltrado"
            :key="h.id_historial"
            color="#294697"
            :icon="soloObservaciones ? 'mdi-comment-text' : 'mdi-checkbox-marked-circle-outline'"
          >
            <div>
              <strong>{{ h.accion_texto }}</strong>
              <div class="grey--text text--darken-2" style="font-size: 13px;">
                <v-icon small class="mr-1" color="primary">mdi-account</v-icon>
                {{ h.nombre_usuario || 'Usuario desconocido' }}
              </div>
              <div class="grey--text text--darken-2" style="font-size: 13px;">
                <v-icon small class="mr-1" color="info">mdi-comment-text</v-icon>
                {{ h.observaciones !== undefined ? h.observaciones : '' }}
              </div>
              <div class="grey--text" style="font-size: 12px;">
                {{ h.fecha }}
              </div>
            </div>
          </v-timeline-item>
        </v-timeline>
        <div v-if="!historial.length" class="text-center grey--text">Sin historial para este caso.</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#294697" text @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';
import env from '../../env';

export default {
  name: 'CaseHistoryTimeline',
  props: {
    caseId: {
      type: [String, Number],
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    soloObservaciones: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      historial: [],
      internalVisible: this.visible
    };
  },
  computed: {
    historialFiltrado() {
      if (this.soloObservaciones) {
        return this.historial.filter(h => h.accion == 10);
      }
      return this.historial;
    }
  },
  watch: {
    visible(val) {
      this.internalVisible = val;
      if (val) {
        this.fetchHistorial();
      }
    },
    internalVisible(val) {
      if (!val) this.$emit('update:visible', false);
    },
    caseId: {
      immediate: true,
      handler() {
        if (this.internalVisible) {
          this.fetchHistorial();
        }
      }
    }
  },
  methods: {
    fetchHistorial() {
      if (!this.caseId) return;
      axios.get(`${env.endpoint}historial/obtener_historial/${this.caseId}`)
        .then(res => {
          this.historial = res.data;
        })
        .catch(() => {
          this.historial = [];
        });
    },
    close() {
      this.internalVisible = false;
    }
  }
};
</script>
